import useTranslate from '@hooks/useTranslate';
import { Button, Form, Input, Modal } from 'antd';
import { FunctionComponent, useEffect } from 'react';
import componentContent from '../TribesPage.content.json';
import { closeModal } from '@stores/modals';
import { editTribe, reset } from '@stores/tribes';
import { useForm } from 'antd/lib/form/Form';
import TextArea from 'antd/lib/input/TextArea';
import { mapDataToFieldsValue, mapValueToRequest } from './TribesEditModal.helpers';
import { ITribes, ITribesFormValue } from '@interfaces/ITribes';

const TribesEditModal: FunctionComponent<{ data?: ITribes }> = ({ data }) => {
  const content = useTranslate(componentContent);
  const [form] = useForm();

  const onFinish = (values: ITribesFormValue) => {
    const dataForRequest: any = mapValueToRequest(values);

    if (data?.id) {
      editTribe({
        ...dataForRequest,
        id: data.id,
      });
    }
    closeModal({ name: 'tribes' });
  };

  useEffect(() => {
    if (data) {
      const fieldsValue = mapDataToFieldsValue(data);
      form.setFieldsValue(fieldsValue);
    } else {
      form.resetFields();
    }
  }, [data, form]);

  return (
    <Modal
      title={content.edit_description}
      visible
      onCancel={() => closeModal({ name: 'tribes' })}
      footer={[
        <Button
          key='submit'
          type='default'
          htmlType='submit'
          onClick={form.submit}
        >
          {content.save}
        </Button>,
        <Button
          key='cancel'
          type='primary'
          onClick={() => closeModal({ name: 'tribes' })}
        >
          {content.cancel}
        </Button>,
      ]}
    >
      <Form
        form={form}
        onFinish={onFinish}
      >
        <Form.Item name='about'>
          <TextArea rows={8} />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default TribesEditModal;
